module.exports = __webpack_public_path__ + "img/vg.e7c6020.svg";